import { useRef, useEffect } from "react";
import { ChatBotModel } from "../handlers/ChatBotModel.ts";
import { setTypingMessageEffect, useChatbotSelector } from "../store/ChatBotStore.ts";
import { useChatBotScroll } from '../hooks/useChatBotScroll.tsx';
import Markdown from 'markdown-to-jsx';
import { MDBBtn, MDBCardBody, MDBIcon } from "mdb-react-ui-kit";
import TypingMessage from "../../../components/TypingEffect.tsx";
import { ChatBotHelper } from "../handlers/ChatBotHelper.ts";
import React from "react";

export interface ChatBotList {
    dispatch: any,
    activeTab: string,
    isReceiverLoader: boolean,
    typingMessageEffect: boolean,
}
const TAG = "[ChatBotList.tsx]."
const ChatBotList: React.FC<ChatBotList>= ({ dispatch, activeTab, isReceiverLoader, typingMessageEffect }) =>{

    const lastAnimatedIndexRef = useRef<number>(-1);

    const messages: ChatBotModel[] =
        useChatbotSelector((state) =>state.chatbot.byType[activeTab]) || [];

    const { endRef: scrollRef, isScrollingUpRef, handleScroll } = useChatBotScroll([messages]);

    useEffect(() =>{
        const handleVisibilityChange = () =>{
            if (document.visibilityState !== "visible") return;

            if (typingMessageEffect) {
                dispatch(setTypingMessageEffect(false));
                console.log(`User switched tabs while typing the message`);
            }

            requestAnimationFrame(() =>{
                scrollRef?.current?.scrollIntoView({ behavior: "auto" });
            });
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () =>{
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [typingMessageEffect, scrollRef]);
    
    const handleRetry = (failedMsg: ChatBotModel) =>{
        try {

            if (isReceiverLoader) {// check loader is true or false

                console.log("currently one message is process please wait for message to complete");
                return;
            }

            ChatBotHelper.getInstance().retryFailedMessage(failedMsg, activeTab);
        } catch (e) {
            console.log(TAG + "[handleRetry] Exception:: " + e);
        }
    }

    return (
        <MDBCardBody className="chat-body" onScroll={handleScroll}>
            <div className="chatbot-messages" >
                {messages.map((msg, index) => {
                    const isSender: boolean = ((msg.sender === "user") || false);
                    const isReceiveLoaderShow: boolean = (index === messages.length - 1) ? !isReceiverLoader : true;
                    const isfailedMsg: boolean = ((isSender && isReceiveLoaderShow && !msg.isMsgReceived) || false);
                    return (
                        <div key={index}
                            className={`d-flex flex-row align-items-start ${isSender? "align-items-end" : "align-items-start"} mb-4 flex-column`}>

                            {typingMessageEffect && msg.sender !== "user" && index === messages.length - 1
                                && lastAnimatedIndexRef.current !== index ? (
                                <TypingMessage
                                    text={msg.text?.toString() || ""}
                                    className={`message-content recived-msg`}
                                    scrollRef={scrollRef}
                                    messageIndex={index}
                                    setAnimatedIndex={(i) => {
                                        lastAnimatedIndexRef.current = i;
                                    }}
                                    isScrollingUpRef={isScrollingUpRef}
                                    isWordEffect={false}
                                />
                            ) : (
                                <>
                                    <Markdown className={`message-content ${isSender ? "sender-msg" : "recived-msg"}`}
                                        options={{
                                            overrides: {
                                                a: {
                                                    props: {
                                                        target: "_blank",
                                                        rel: "noopener noreferrer"
                                                    }
                                                }
                                            }
                                        }}>
                                        {ChatBotHelper.getInstance().autoLinkifyMarkdown(msg.text)}

                                    </Markdown>
                                    {isfailedMsg && 
                                        (<> 
                                            <div className="mt-2 pe-2">
                                                <span className="pe-2">Something went wrong.</span>
                                                <MDBIcon fas icon="info-circle" />
                                            </div>
                                            <MDBBtn rounded outline color="secondary" className="py-1" onClick={() =>handleRetry(msg)} disabled={isReceiverLoader}>
                                            <MDBIcon fas icon="redo" style={{ transform: 'scaleX(-1)' }} />Retry</MDBBtn>
                                        </>)}
                                </>
                            )}
                        </div>
                    );
                })}

                {isReceiverLoader && (
                    <div className="typing-indicator">
                        <div className="typing-dots">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                )}

                <div ref={scrollRef} />
            </div>
        </MDBCardBody>
    );
};

export default ChatBotList;